import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { INVITATIONS_QUERY_KEY } from "./query.key";

export const queryOptions_validate_invite_token = (
  params: Parameters<typeof api.invitation.validateInvitation>[0],
) =>
  queryOptions({
    queryKey: [INVITATIONS_QUERY_KEY, params] as const,
    queryFn: () => extractionWrapper(api.invitation.validateInvitation(params)),
    placeholderData: keepPreviousData,
  });
